import "./AltHintBadge.css";

export function AltHintBadge({ label, visible = false }) {
  if (!visible) {
    return null;
  }

  return (
    <span class="alt-hint-badge">
      {label}
    </span>
  );
}
